import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllDiscountCodes = (query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.fetchAllDiscountCodes(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_DISCOUNT_CODES_FAILED,
              reject: actionTypes.FETCH_ALL_DISCOUNT_CODES_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_DISCOUNT_CODES_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_DISCOUNT_CODES_SUCCESS, res);
  return request();
};

export const fetchDiscountCodeById = (id) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.fetchDiscountCodeById(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_DISCOUNT_CODE_BY_ID_FAILED,
              reject: actionTypes.FETCH_DISCOUNT_CODE_BY_ID_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_DISCOUNT_CODE_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_DISCOUNT_CODE_BY_ID_SUCCESS, res);
  return request();
};



export const insertNewDiscountCode = (discountCodeObject) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.insertNewDiscountCode(discountCodeObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_DISCOUNT_CODE_FAILED,
              reject: actionTypes.INSERT_NEW_DISCOUNT_CODE_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_DISCOUNT_CODE_LOADING);
  const success = res => action(actionTypes.INSERT_NEW_DISCOUNT_CODE_SUCCESS, res);
  return request();
};



export const updateDiscountCode = (discountCodeObject) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.updateDiscountCode(discountCodeObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_DISCOUNT_CODE_FAILED,
              reject: actionTypes.UPDATE_DISCOUNT_CODE_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_DISCOUNT_CODE_LOADING);
  const success = res => action(actionTypes.UPDATE_DISCOUNT_CODE_SUCCESS, res);
  return request();
};



export const updateDiscountCodeStatus = (id, status) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.updateDiscountCodeStatus(id, status)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_DISCOUNT_CODE_STATUS_FAILED,
              reject: actionTypes.UPDATE_DISCOUNT_CODE_STATUS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_DISCOUNT_CODE_STATUS_LOADING);
  const success = res => action(actionTypes.UPDATE_DISCOUNT_CODE_STATUS_SUCCESS, res);
  return request();
};


export const createRandomCode = () => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.createRandomCode()
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CREATE_RANDOM_DISCOUNT_CODE_FAILED,
              reject: actionTypes.CREATE_RANDOM_DISCOUNT_CODE_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CREATE_RANDOM_DISCOUNT_CODE_LOADING);
  const success = res => action(actionTypes.CREATE_RANDOM_DISCOUNT_CODE_SUCCESS, res);
  return request();
};


export const fetchSearchedSpecialUsers = (searchKey) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.fetchSearchedSpecialUsers(searchKey)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.SPECIAL_SEARCHED_USERS_FAILED,
              reject: actionTypes.SPECIAL_SEARCHED_USERS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.SPECIAL_SEARCHED_USERS_LOADING);
  const success = res => action(actionTypes.SPECIAL_SEARCHED_USERS_SUCCESS, res);
  return request();
};


export const fetchAllDiscountCodeUsers = (id, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.discountCodes.fetchAllDiscountCodeUsers(id, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DISCOUNT_CODE_USERS_FAILED,
              reject: actionTypes.DISCOUNT_CODE_USERS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DISCOUNT_CODE_USERS_LOADING);
  const success = res => action(actionTypes.DISCOUNT_CODE_USERS_SUCCESS, res);
  return request();
};
